import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return window.localStorage.getItem("n3-lang") === "ro" ? "ro" : "en";
    } catch (e) {
      return "en";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      window.localStorage.setItem("n3-lang", l);
    } catch (e) {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, toggle: () => setLang(lang === "en" ? "ro" : "en") }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);

export const useT = () => {
  const { lang } = useLang();
  return (pair) => {
    if (pair == null) return "";
    if (typeof pair === "string") return pair;
    return pair[lang] || pair.en || "";
  };
};

export const useCopy = () => {
  const { lang } = useLang();
  return (en, ro) => lang === 'ro' ? ro : en;
};
